<template>  
  <div class="animated fadeIn">
    <table-reestr 
      ref="base-card"
      :showAddButton="true"
      :getDataFunction="getReestrs"
      :isBusy="reestrTableIsBusy" 
      :showCompanyName="isSuperAdmin || isEnergyCompany"
      @onAdd="onAddClick"
      @rowClicked="item => $router.push({ path: `/acts-reestr/${item.id}`})"
    >
      <template v-slot:filter>
        <b-nav-form variant="info">
          <b-input-group v-if="isSuperAdmin || isEnergyCompany" class="mr-2 mb-2" prepend="Компания">
            <b-form-select :options="companies" text-field="nameCount" value-field="id" v-model="filterIdCompany"></b-form-select>
            <b-overlay :show="tableCompaniesBusy" no-wrap></b-overlay>
          </b-input-group>
          <b-input-group class="mr-2 mb-2" prepend="Энергоноситель">
            <b-form-select :options="[{text: 'Все', value: null},{text: 'холодная вода', value: 'coldwater'},{text: 'горячая вода', value: 'hotwater'}]" v-model="filterEnergyType"></b-form-select>
          </b-input-group>
          <b-input-group class="mr-2 mb-2" prepend="Серийный номер">
            <b-form-input type="number" v-model="filterSerialNumber"></b-form-input>
          </b-input-group>
          <b-input-group class="mr-2 mb-2" prepend="Статус">
            <b-form-select :options="[{text: 'Все', value: null},{text: 'создан', value: 'created'},{text: 'подписан', value: 'signed'}]" v-model="filterStatus"></b-form-select>
          </b-input-group>
        </b-nav-form>
      </template>

      <template v-slot:actions="props">
        <button-delete v-if="props.item.idCompany == idCompany && props.item.status === 'created'" @click="onDeleteClick(props.item.id)" class="ml-1"/>
        <button-info @click="$router.push({ path: `/acts-reestr/${props.item.id}`})" class="ml-1"/>
        <b-dropdown v-if="isAdminEnergyCompany" size="sm" class="ml-1" variant="warning" right text="Действие">
          <b-dropdown-item-button @click="onSingn(props.item.id, 'signed')">Подписать</b-dropdown-item-button>
          <b-dropdown-item-button @click="onSingn(props.item.id, 'created')">Отменить подпись</b-dropdown-item-button>            
        </b-dropdown>
        <button-excel class="ml-1" @click="onReportClick(props.item.id)"></button-excel>
      </template>
    </table-reestr>

    <b-modal 
      centered 
      id="modal-reestr-add" 
      title="Создать реестр" 
      class="modal-warning" 
      size="md"
      header-bg-variant="warning"
      ok-variant="warning"
      :ok-disabled="reestrEnergyType === null || reestrDate === null"
      @ok ="onModalClick"
    >
    <div class="d-flex flex-column">
      <b-input-group class="mr-2 mb-2" prepend="Энергоноситель">
        <b-form-select :options="[{text: 'холодная вода', value: 'coldwater'},{text: 'горячая вода', value: 'hotwater'}]" v-model="reestrEnergyType"></b-form-select>
      </b-input-group>
      <b-input-group class="mb-2 mr-2" prepend="Дата">
        <b-form-input type="date" v-model="reestrDate" ></b-form-input>
      </b-input-group>
    </div>
    </b-modal>

    <report-viewer-modal :id="'report-viewer-modal-reestr'+reportId" title="Печать реестра" :reportType="currentReport.reportType" :report="currentReport.dataReport" :customVariables="reportVariables" :dataSets="null"/>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import TableReestr from './TableReestr.vue'
  import ReportViewerModal from '@/views/reports/ViewerModal.vue'
  import CompaniesService from '@/services/web/companies.service'
  import TaskService from '@/services/web/task.service'
  import ReportService from '@/services/web/report.service'

export default {
  name: 'reestrs',
  components: {TableReestr, ReportViewerModal},
  data: function() {
    return {    
      currentReport: {},
      reportId: '',
      reportVariables: [{name: 'IdReestr', value: null}],
    
      reestrDate: null,
      reestrEnergyType: null,

      companies: [],
      tableCompaniesBusy: false,

      filterIdCompany: null,
      filterEnergyType: null,
      filterSerialNumber: null,
      filterStatus: null,
      
      reestrTableIsBusy: false,
    }
  },    

  computed: {
    ...mapGetters(['isSuperAdmin', 'isEnergyCompany', 'isAdminEnergyCompany', 'idCompany'])
  },

  watch: {
    filterIdCompany: function(val) {
      this.$refs['base-card'].getData()
    },
    filterEnergyType: function(val) {
      this.$refs['base-card'].getData()
    },
    filterSerialNumber: function(val) {
      this.$refs['base-card'].getData()
    },
    filterStatus: function(val) {
      this.$refs['base-card'].getData()
    },
  },

  methods: {
    onReportClick(idReestr) {
      let idReestrVar = this.reportVariables[0]
      this.$set(idReestrVar, 'value', idReestr)
      this.$bvModal.show('report-viewer-modal-reestr'+this.reportId)
    },

    onSingn(id, status) {
      TaskService.updateActReestr(id, status)
      .then(() => {        
        this.$refs['base-card'].getData()
      })
      .catch(exc => { 
        console.log('Error onSingn!')
        this.showDangerMessage(exc) 
      })
    },

    onAddClick() {
      this.reestrDate = this.dateFormat(Date.now(), 'yyyy-mm-dd')
      this.$bvModal.show('modal-reestr-add')
    },

    onModalClick() {
      TaskService.createActReestr(this.reestrEnergyType, this.reestrDate)
      .then(res => {
        this.$refs['base-card'].getData()
      })
      .catch(exc => { 
        this.showDangerMessage(exc) 
      })
    },

    onDeleteClick(id) {
      this.showConfirmMessage('Вы уверены, что хотите удалить реестр?')
      .then(() => {
        return TaskService.deleteActReestr(id)
      })
      .then(() => {        
        this.$refs['base-card'].getData()
      })
      .catch(exc => { 
        console.log('Error onDeleteClick!')
        this.showDangerMessage(exc) 
      })
    },

    getReestrs(currentPage, perPage) {
      return TaskService.getActReestrs(
                      this.filterIdCompany, 
                      this.filterSerialNumber, 
                      this.filterStatus,
                      this.filterEnergyType,
                      currentPage, 
                      perPage)           
    },

    getCompanies() {
      this.tableCompaniesBusy = true
      
      CompaniesService.get(null, null, null, 1, 100)
      .then(response  => {
        if (response.data != null && response.data.data != null) {
          this.tableCompaniesBusy = false
          this.companies = []

          if (response.data.data !== null) {
            this.companies.push({nameCount: 'все', id: null})
            response.data.data.forEach(e => {
              this.$set(e, 'nameCount', `${e.name}`)
              this.companies.push(e)
            })            
          }
        }
      }).catch( exc => {
        this.tableCompaniesBusy = false
        console.log('Error getCompanies() ' + exc)
      })
    },

    getReports() {
      ReportService.get(null, 'reestr-acts', null)
      .then(result => {
        if(result.data && result.data.length >= 0) {
          this.currentReport = result.data[0]
        }
      })
      .catch( exc => {        
        console.log('Error getReports() ' + exc)
      })
    }
  },

  mounted() {
    this.getCompanies()
    this.getReports()
    this.reportId = String(Math.random()) // crypto.randomUUID()
  }
}
</script>
 